import StoredLayout from '../../layouts/StoredLayout'
import ReactDatetime from './ReactDatetime'
export default StoredLayout(ReactDatetime)
